<div class="conteneur-contacter-ma-caf-reponses-cnaf">
    <br>
    <div class="row">
        <div class="col-xs-12">
            <cnaf-camille-header [etat]="etatCamille" [question]="questionCamille" [formuel]="formuel">
            </cnaf-camille-header>
            <div [ngClass]="{'filet-block-camille' : etatCamille === 'reponses'}">
                <div class="panel-group">
                    <div *ngFor="let resultat of reponsesCamille?.resultats | slice:0:limit; trackBy:resultatById"
                        [attr.disabled]="resultat.lien ?  'disabled' : null" [ngClass]="(!resultat.isLu ? 'noprint':'')"
                        class="panel">
                        <div class="row no-margin">
                            <div class="collapsable-heading-cnaf" (click)="!resultat.lien && resultat.etatArticle !== 'loading' 
                                ? openClose(reponsesCamille.resultats.indexOf(resultat))
                                : resultat.lien ? ouvrirLien(resultat)
                                : ''">
                                <div class="col-xs-12 panel-heading">
                                    <div *ngIf="!resultat.lien"
                                        class="{{resultat.open ? 'ferme' : 'ouvert'}}-cnaf padding-header-cnaf">
                                        <a role="button" href="javascript:void(0);" [attr.aria-expanded]="resultat.open"
                                            attr.aria-controls="article-contenu-{{reponsesCamille.resultats.indexOf(resultat)}}"
                                            class="label-form-cnaf custom-label panel-title"
                                            [textContent]="resultat.titre"></a>
                                    </div>
                                    <div *ngIf="resultat.lien" class="padding-header-cnaf picto-lien-cnaf">
                                        <span class="label-form-cnaf custom-label panel-title"
                                            [textContent]="resultat.titre"></span>
                                    </div>
                                    <div class="filet-header-camille noprint" [hidden]="resultat.open"></div>
                                </div>
                            </div>
                        </div>
                        <div class="collapsable-body-cnaf panel-collapse collapse in" [hidden]="!resultat.open"
                            id="article-contenu-{{reponsesCamille.resultats.indexOf(resultat)}}">
                            <div class="row panel-body" [ngSwitch]="resultat.etatArticle">
                                <div class="col-xs-12">
                                    <div class="conteneur-accordeon-reponses">
                                        <div class="progress" *ngSwitchCase="'loading'">
                                            <div class="progress-bar progress-bar-info progress-bar-striped active"
                                                role="progressbar">
                                                Chargement en cours...
                                            </div>
                                        </div>
                                        <div *ngSwitchCase="'loaded'" class="no-shadow-box"
                                            [innerHTML]="resultat.contenu! | safeHtml" cnaf-affiche-article>
                                        </div>
                                        <div *ngSwitchCase="'error'">
                                            <div class="alert alert-danger" role="alert">
                                                <span class="glyphicon glyphicon-alert"></span>
                                                <p class="inline-cnaf">Un incident technique s'est produit.
                                                    <br aria-hidden="true" />Merci de renouveler votre démarche.
                                                </p>
                                            </div>
                                        </div>
                                        <div *ngSwitchCase="'vide'" class="noprint">
                                            <div class="alert alert-info">
                                                <span class="glyphicon glyphicon-info-sign"></span>
                                                <p class="inline-cnaf">Aucun contenu n'est disponible pour le moment.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="filet-panel-camille filet-panel-camille-print"
                                        [hidden]="!resultat.open"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="reponsesCamille?.resultats && reponsesCamille.resultats.length > 5" class="noprint">
                    <div class="clearfix">
                        <div class="pull-right">
                            <div class="{{limit === 5 ? 'chevron-plus' : 'chevron-moins'}}-cnaf"
                                (click)="voirPlusMoins()">
                                <div class="conteneur-plus-reponses">
                                    <a href="javascript:void(0);" class="plus-reponses-cnaf"
                                        [attr.aria-expanded]="limit === 10">
                                        {{limit === 5 ? 'Voir plus de réponses' : 'Voir moins de réponses'}}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <form [formGroup]="myForm" (ngSubmit)="submitOrBlur()" #reponsesCourrielNgForm="ngForm" autocomplete="off"
        class="margin-top-15">
        <div class="row noprint" id="enquete-camille">
            <div class="col-xs-12" [hidden]="etatCamille !== 'reponses'">
                <label class="label-form-cnaf">Ai-je répondu à votre question ?</label>
                <p class="texte-clair-cnaf complement-label">En cliquant sur non, vous avez la possibilité de modifier
                    votre demande ou d'envoyer un mail à votre Caf.</p>
                <div class="btn-group btn-block" ngCnafRadioGroup formControlName="satisfaction">
                    <label for="satisfactionOui" ngCnafButtonLabel class="btn btn-default btn-camille-small">
                        <input type="radio" (click)="tagguerClick('satisfait')" id="satisfactionOui" name="satisfaction"
                            aria-label="Oui" class="sr-only" ngCnafButton value="true" />
                        <span aria-hidden="true">Oui</span>
                    </label>
                    <label for="satisfactionNon" ngCnafButtonLabel class="btn btn-default btn-camille-small">
                        <input type="radio" (click)="tagguerClick('non_satisfait')" id="satisfactionNon"
                            name="satisfaction" aria-label="Non" class="sr-only" ngCnafButton value="false" />
                        <span aria-hidden="true">Non</span>
                    </label>
                </div>
            </div>
            <div class="col-xs-12 margin-top" [hidden]="!(etatCamille === 'reponses' && myForm.controls['satisfaction'].value === 'false') &&
            etatCamille !== 'resultatsVide'">
                <label class="label-form-cnaf">Vous pouvez maintenant modifier votre question ou écrire un mail
                    :</label>
                <div class="btn-group btn-block margin-top-10" ngCnafRadioGroup formControlName="actionReponses">
                    <label for="actionModifier" ngCnafButtonLabel class="btn btn-default btn-camille-large">
                        <input type="radio" (click)="triggerAction('modifier')" id="actionModifier" name="action"
                            aria-label="Modifier" class="sr-only" ngCnafButton value="modifier" />
                        <span aria-hidden="true">Modifier</span>
                    </label>
                    <label for="actionEcrire" ngCnafButtonLabel [attr.disabled]="isCheckboxDisabled? 'disabled':null"
                        class="btn btn-default btn-camille-large">
                        <input type="radio" id="actionEcrire" name="action" (click)="triggerAction('ecrire')"
                            aria-label="Écrire" class="sr-only" ngCnafButton value="ecrire" />
                        <span aria-hidden="true">Écrire</span>
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group margin-top-15" [hidden]="!(etatCamille === 'reponses' && myForm.controls['satisfaction'].value === 'false' && myForm.controls['actionReponses'].value === 'ecrire') &&
        !(etatCamille === 'resultatsVide' && myForm.controls['actionReponses'].value === 'ecrire') &&
        etatCamille !== 'error'">
            <label class="label-form-cnaf margin-top" for="idCourriel">Vous pouvez rédiger votre mail et le transmettre
                à votre Caf en cliquant sur le bouton « Envoyer ».</label>
            <div
                [ngClass]="{'has-error': (submitted || myForm.controls['texteCourriel'].touched) && myForm.controls['texteCourriel'].errors }">
                <textarea class="form-control textarea-courriel-cnaf margin-top-10" id="idCourriel" rows="5"
                    name="texteCourriel" placeholder="Saisissez votre message..."
                    [attr.aria-invalid]="!myForm.controls['texteCourriel'].value" formControlName="texteCourriel"
                    aria-describedby="messageHelp messageError" title="champ obligatoire" [attr.required]="'required'">
        </textarea>
                <span class="sr-only" id="messageHelp">Champ obligatoire</span>
                <div id="messageError"
                    *ngIf="!(myForm.controls.texteCourriel.errors && (submitted || myForm.controls.texteCourriel.touched))">
                </div>
                <div role="alert"
                    *ngIf="(submitted || myForm.controls['texteCourriel'].touched) && myForm.controls['texteCourriel'].errors"
                    class="help-block">
                    <p *ngIf="myForm.controls['texteCourriel'].errors?.required" id="messageError">Champ obligatoire</p>
                </div>
            </div>
        </div>
        <div class="form-group text-center noprint">
            <br />
            <p class="text-left" [hidden]="!(etatCamille === 'reponses' && myForm.controls['satisfaction'].value === 'false' &&  myForm.controls['actionReponses'].value === 'ecrire') &&
            !(etatCamille === 'resultatsVide' && myForm.controls['actionReponses'].value === 'ecrire') &&
            etatCamille !== 'error'">
                En envoyant votre mail, vous allez recevoir un accusé de réception. Si tel n'est pas le cas, merci de
                vérifier l'adresse mail enregistrée dans « Mon Profil ».
            </p>
            <div class="col-xs-8 col-xs-offset-2 col-sm-4 col-sm-offset-0">
                <button *ngIf="(etatCamille === 'reponses' && myForm.controls['satisfaction'].value === 'false' && myForm.controls['actionReponses'].value === 'ecrire') ||
                (etatCamille === 'resultatsVide' && myForm.controls['actionReponses'].value === 'ecrire') ||
                etatCamille === 'error'" type="button"
                    class="btn btn-form-cnaf btn-block btn-secondaire-cnaf btn-reponses align-middle-cnaf"
                    (click)="confirmerClick()">
                    Quitter
                </button>
                <button *ngIf="etatCamille === 'reponses' && myForm.controls['satisfaction'].value === 'true'"
                    type="button" class="btn btn-form-cnaf btn-block btn-secondaire-cnaf btn-reponses align-middle-cnaf"
                    (click)="tagguerClick('quitter_satisfait');redirect('/redirect/s/Redirect?page=monCompteContactCaf#/contactcaf')">
                    Quitter
                </button>
            </div>
            <div class="col-xs-8 col-xs-offset-2 col-sm-4 col-sm-offset-4">
                <button *ngIf="etatCamille === 'reponses' && myForm.controls['satisfaction'].value === 'true'"
                    class="btn btn-form-cnaf btn-block btn-secondaire-cnaf btn-impression align-middle-cnaf more-margin-top"
                    (click)="imprimer()">
                    Imprimer
                </button>
                <button *ngIf="(etatCamille === 'reponses' && myForm.controls['satisfaction'].value === 'false' && myForm.controls['actionReponses'].value === 'ecrire') ||
                (etatCamille === 'resultatsVide' && myForm.controls['actionReponses'].value === 'ecrire') ||
                etatCamille === 'error'" type="submit"
                    class="btn btn-form-cnaf btn-block btn-active-cnaf btn-reponses align-middle-cnaf height-auto more-margin-top"
                    [attr.disabled]="isEnvoiDisabled ? 'disabled':null">
                    Envoyer
                </button>
            </div>
        </div>
    </form>
</div>